module.exports = __webpack_public_path__ + "static/media/ghassen_image.56d1d452.png";